<template>
  <div>
    <div class="tabDiv" style="margin-top: 20px;">
      <div class="table-header">
        <table border="0" cellpadding="0" cellspacing="0" class="lot-table-header">
          <thead>
          <tr>
            <th class="tab-img">{{ meetingStatus === '已成交' ? '标的名称' : '拍卖会名称' }}</th>
            <th class="tab-price">{{ meetingStatus === '已成交' ? '成交金额' : '保证金金额' }}</th>
            <th class="tab-status">拍卖会状态</th>
            <th class="tab-time">时间</th>
            <th class="tab-button">操作</th>
          </tr>
          </thead>
        </table>
      </div>
      <div v-for="(item,index) in (meetingStatus === '已成交' ? AuctionData : data)" :key="index" class="tableDiv">
        <table border="0" cellpadding="0" cellspacing="0" class="lot-table">
          <tbody>
          <tr>
            <td class="tab-img">
              <template v-if="meetingStatus === '已成交'">
                <img v-if="item.lotImg && item.lotImg.length > 0" :src="item.lotImg[0].link" alt="">
                <el-tooltip :content="item.lotName" class="item" effect="dark" placement="bottom-start">
                  <span class="lot-name-span">{{ item.lotName }}</span>
                </el-tooltip>
              </template>
              <!-- 非已成交状态显示拍卖会名称 -->
              <template v-else>
                <el-tooltip :content="item.meetingName" class="item" effect="dark" placement="bottom-start">
                  <span class="lot-name-span">{{ item.meetingName }}</span>
                </el-tooltip>
              </template>
            </td>
            <td class="tab-price">
              <span v-if="meetingStatus !== '已成交'" class="money">￥{{ item.totalDeposit }}元</span>
              <span v-else class="money">￥{{ item.price }}元</span>
            </td>
            <td class="tab-status">
               <span class="auction-status">{{
                   item.backOutStatus == 1 ? '撤拍' :
                       (meetingStatus !== '已成交' ? formatEnum(item.meetingStatus, auctionStatusOptions) : '已成交')
                 }}</span>
            </td>
            <td class="tab-time">
              <p v-if="meetingStatus !== '已成交'" class="time-box">
                <em>开拍时间</em>
                <br>
                {{ item.startAuctionTime }}
              </p>
              <p v-else class="time-box">
                <em>结束时间</em>
                <br>
                {{ item.endTime }}
              </p>
            </td>
            <td class="tab-button">
              <el-button class="viewButton" plain type="primary" @click="viewLot(item.meetingId,item.lotId)">
                {{ meetingStatus === '已成交' ? '查看标的' : '查看拍卖会' }}
              </el-button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="block">
      <el-pagination
          :current-page="page.currentPage"
          :page-size="page.pageSize"
          :page-sizes="[10,20,30,40,50,100]"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import AuctionStatusOptions from "@/enum/AuctionStatusOptions";
import {cmsPageMyAuction, pageMine} from "@/api/biz/auction/lotApply";

export default {
  name: 'myBidTable',
  computed: {
    ...mapGetters(["userInfo"]),
  },
  props: {
    meetingStatus: String
  },
  data() {
    return {
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      data: [],
      AuctionData: [],
      auctionStatusOptions: [],
      isLoading: false // 添加加载状态
    }
  },
  watch: {
    userInfo: {
      handler(newUserInfo) {
        // 当 userInfo 存在且包含 user_id 时，调用 init（避免重复调用）
        if (newUserInfo && newUserInfo.user_id &&
            ((this.meetingStatus === '已成交' && !this.AuctionData.length) ||
                (this.meetingStatus !== '已成交' && !this.data.length))) {
          this.init();
        }
      },
      deep: true, // 若 userInfo 是对象，需深度监听
      immediate: true // 初始化时立即检查一次
    },
    meetingStatus: {
      handler(newVal, oldVal) {
        // 当 meetingStatus 变化时重新加载数据
        if (oldVal !== undefined && newVal !== oldVal) {
          // 重置分页和数据
          this.page.currentPage = 1;
          this.data = [];
          this.AuctionData = [];
          this.init();
        }
      },
      immediate: true
    }
  },
  methods: {
    // 格式化数据
    formatEnum(key, child) {
      for (var index in child) {
        if (child[index].key == key) {
          return child[index].value;
        }
      }
      return "";
    },
    viewLot(meetingId, lotId) {
      if (this.meetingStatus === '已成交') {
        this.$router.push({path: "/lotDetail", query: {lotId: lotId}})
      } else {
        // 其他情况跳转到拍卖会详情页
        this.$router.push({path: "/meetingDetial", query: {meetingId: meetingId}})
      }
    },
    init() {
      let params = {
        meetingStatus: this.meetingStatus
      };
      this.onLoad(this.page, params);
      this.auctionStatusOptions = AuctionStatusOptions;
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.onLoad(this.page);
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.onLoad(this.page);
    },
    onLoad(page, params) {
      if (this.isLoading) return;
      this.isLoading = true;
      if (this.meetingStatus === '已成交') {
        const AuctionParams = {
          bidderId: this.userInfo.user_id,
          auctionStatus: 99
        };
        cmsPageMyAuction(page.currentPage, page.pageSize, AuctionParams)
            .then(res => {
              const data = res.data.data;
              this.page.total = data.total;
              this.AuctionData = data.records;
              this.lotId = this.AuctionData.map(item => item.lotId);
            })
            .catch(error => {
              console.error('获取已成交数据失败:', error);
              // 显示友好的错误提示
              this.$message.error(`获取已成交数据失败: ${error.message}`);
              this.data = [];
              this.page.total = 0;
            }).finally(() => {
          this.isLoading = false; // 请求完成后重置状态
        });
      } else {
        // 其他状态调用 pageMine 接口
        pageMine(page.currentPage, page.pageSize, params).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
        }).catch(error => {
          console.error('获取报名数据失败:', error);
          this.$message.error('获取报名数据失败');
          this.data = [];
          this.page.total = 0;
        }).finally(() => {
          this.isLoading = false; // 请求完成后重置状态
        });
      }
    }
  }
}
</script>

<style>
.lot-name-span {
  flex: 1; /* 占据父容器剩余所有宽度（图片占120px+10px间距后） */
  display: inline-block;
  white-space: nowrap; /* 文字不换行 */
  overflow: hidden; /* 超出部分隐藏 */
  text-overflow: ellipsis; /* 超出部分显示省略号（优化体验） */
  line-height: 1.2; /* 避免文字因行高过大导致垂直偏移 */
}

.tab-img img {
  width: 120px;
  height: 80px;
  object-fit: cover; /* 避免图片拉伸变形（可选，优化体验） */
  margin-right: 10px; /* 与名称保持间距，避免遮挡 */
  margin-left: 0; /* 清除不必要的左 margin，依赖父容器padding对齐 */
}

.lot-table td.tab-img {
  width: 30%; /* 与表头th.tab-img宽度一致（原表头th第1列宽30%） */
  display: flex; /* 开启Flex布局，子元素横向排列 */
  align-items: center; /* 子元素垂直居中（图片和文字对齐） */
  padding: 0 16px; /* 左右内边距，避免内容贴边 */
  border-right: 1px solid #d7d7d7;
  height: 80px; /* 与表格行高一致 */
  box-sizing: border-box; /* 确保width包含padding，避免溢出 */
}

.lot-table-header, .lot-table {
  box-sizing: border-box; /* 宽度=内容+内边距+边框，避免溢出 */
  border-collapse: collapse; /* 合并边框，避免双重边框 */
}

.lot-table-header th, .lot-table td {
  box-sizing: border-box; /* 确保th和td的宽度计算规则一致 */
  padding: 0 8px; /* 统一内边距，避免内容偏移 */
}

.lot-table-header th {
  float: left;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  color: #333;
  border-right: 1px solid #d7d7d7;

  /* 关键：每列宽度与td完全对应 */
  width: 30%; /* 1. 拍卖会名称（对应td.tab-img） */
}

.lot-table-header th:nth-child(2) {
  width: 15%;
}

/* 2. 保证金金额（对应td.tab-price） */
.lot-table-header th:nth-child(3) {
  width: 15%;
}

/* 3. 拍卖会状态（对应td.tab-status） */
.lot-table-header th:nth-child(4) {
  width: 15%;
}

/* 4. 时间（对应td.tab-time） */
.lot-table-header th:nth-child(5) {
  width: 15%; /* 5. 操作（对应td.tab-button） */
  border-right: none; /* 最后一列去掉右边框 */
}

.lot-table td.tab-price {
  width: 15%;
}

/* 2. 保证金金额（对应th第2列） */
.lot-table td.tab-status {
  width: 15%;
}

/* 3. 拍卖会状态（对应th第3列） */
.lot-table td.tab-time {
  width: 15%;
}

/* 4. 时间（对应th第4列） */
.lot-table td.tab-button {
  width: 15%; /* 5. 操作（对应th第5列） */
  border-right: none; /* 最后一列去掉右边框 */
}

/*.lot-table td.tab-time {
  line-height: normal; !* 清除单行line-height *!
  padding: 18px 8px; !* 上下内边距实现垂直居中 *!
}*/

/*.time-box {
  padding-top: 0; !* 清除原有的padding-top，避免偏移 *!
  margin: 0; !* 清除默认margin *!
}*/

/* 操作列：按钮垂直居中（用flex布局） */
.lot-table td.tab-button {
  line-height: normal; /* 清除单行line-height */
  display: flex; /* flex布局实现按钮居中 */
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}

.viewButton {
  margin: 0; /* 清除原有的margin，避免偏移 */
}

/* 拍卖会名称列：文本垂直居中（图片+文字对齐） */
/*.lot-table td.tab-img {
  line-height: normal;
  display: flex;
  align-items: center; !* 垂直居中 *!
  padding-left: 16px; !* 统一左边距 *!
}*/

.tab-img img {
  margin: 0 10px 0 0; /* 清除原有的margin-left，避免偏移 */
  width: 120px;
  height: 80px;
  float: none; /* 清除float，用flex控制布局 */
}

.lot-name-span {
  width: calc(100% - 130px); /* 自适应剩余宽度（总宽-图片宽-间距） */
}

.table-header {
  width: 96%;
  margin: 0 auto;
  border: 1px solid #d7d7d7;
  border-bottom: none;
  background-color: #f5f7fa;
}

.lot-table-header {
  width: 100%;
  height: 40px;
  margin: 0 auto;
}

.lot-table-header th {
  float: left;
  border-right: 1px solid #d7d7d7;
  line-height: 40px;
  height: 40px;
  font-size: 14px;
  text-align: center;
  font-weight: bold;
  color: #333;
}

.lot-table-header th:last-child {
  border-right: none;
}

.lot-name-span {
  width: 140px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lot-name-span {
  width: 140px;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tableDiv h3 {
  background: #f3f5f7;
  border-bottom: 0;
  line-height: 40px;
  font-size: 14px;
  color: #666;
  font-weight: 400;
  overflow: hidden;
}

.lot-table {
  width: 100%;
  height: 90px;
  margin: 10px auto 0;
}

.lot-table .tab-img {
  width: 294px;
}

.lot-table td {
  width: 165px;
}

.lot-table td {
  float: left;
  border-right: 1px solid #d7d7d7;
  line-height: 80px;
  height: 80px;
  font-size: 12px;
  text-align: center;
}

.lot-table td:last-child {
  line-height: normal;
  border-right: none;
}

.tableDiv {
  width: 96%;
  margin: 18px auto 0;
  border: 1px solid #d7d7d7;
}

.block {
  margin-left: 50%;
  margin-bottom: 2%;
  margin-top: 2%;
}

.viewButton {
  margin-left: 20%;
  margin-top: 10%;
}

.tab-img img {
  vertical-align: middle;
  width: 120px;
  height: 80px;
  float: left;
  margin-right: 10px;
  margin-left: 5%;
}

.tab-price .price-box {
  /* padding: 22px 0 0; */
  line-height: 18px;
}

.time-box {
  line-height: 22px;
  padding-top: 22px;
}

.tab-time em {
  color: #999;
}
</style>
